<template>
  <div id="app">
    <nav class="top-nav">
      <div class="nav-content">
        <!-- 左侧Logo -->
        <div class="nav-left">
          <router-link to="/" class="logo-link">
            <img src="/水滴.svg" alt="Logo" class="logo" />
          </router-link>
          <router-link to="/" class="logo-text">雨瑞资源网</router-link>
        </div>
        <div class="nav-center">
          <div class="nav-links">
<!--            <router-link :to="{ name: 'home' }" class="nav-link" :class="{ active: $route.name === 'home' }">首页</router-link>-->
            <router-link :to="{ name: 'drama' }" class="nav-link" :class="{ active: $route.name === 'drama' }">短剧</router-link>
            <router-link :to="{ name: 'api' }" class="nav-link" :class="{ active: $route.name === 'api' }">API服务</router-link>
            <router-link :to="{ name: 'tools' }" class="nav-link" :class="{ active: $route.name === 'tools' }">常用工具</router-link>
            <!--            <router-link :to="{ name: 'articles' }" class="nav-link" :class="{ active: $route.name === 'articles' }">美文赏析</router-link>-->
            <!--            <router-link :to="{ name: 'tech' }" class="nav-link" :class="{ active: $route.name === 'tech' }">数码科技</router-link>-->
            <router-link :to="{ name: 'ranking' }" class="nav-link" :class="{ active: $route.name === 'ranking' }">排行榜</router-link>
            <router-link :to="{ name: 'votes' }" class="nav-link" :class="{ active: $route.name === 'votes' }">投票</router-link>
            <router-link :to="{ name: 'community' }" class="nav-link" :class="{ active: $route.name === 'community' }">社区交流</router-link>
          </div>
        </div>
        <!-- 右侧用户区域 -->
        <div class="nav-right">
<!--          <el-button type="primary" class="publish-btn" @click="handlePublish">发布</el-button>-->

          <!-- 未登录状态 -->
          <el-button v-if="!userStore.isLoggedIn"
                     type="primary"
                     plain
                     @click="$router.push('/login')">
            登录
          </el-button>

          <!-- 已登录状态 -->
          <el-dropdown v-else @command="handleCommand">
            <div class="user-profile">
              <el-avatar
                  :size="32"
                  :src="userStore.userInfo?.avatar || defaultAvatar"
              />
              <span class="username">{{ userStore.userInfo?.username }}</span>
              <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon><user /></el-icon>个人信息
                </el-dropdown-item>
                <el-dropdown-item command="settings">
                  <el-icon><setting /></el-icon>账号设置
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <el-icon><switch-button /></el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </nav>
   <router-view/>
    <Footer />
  </div>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowDown, User, Setting, SwitchButton } from '@element-plus/icons-vue'
import Footer from '@/components/Footer.vue'
import Logo from '@/components/Logo.vue'

const router = useRouter()
const userStore = useUserStore()
const defaultAvatar = '/path/to/default-avatar.png'

// 处理发布按钮点击
const handlePublish = () => {
  if (!userStore.isLoggedIn) {
    ElMessage.warning('请先登录后再发布内容')
    router.push('/login')
    return
  }
  // TODO: 跳转到发布页面
  router.push('/publish')
}

// 处理下拉菜单命令
const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/profile')
      break
    case 'settings':
      router.push('/settings')
      break
    case 'logout':
      ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userStore.logout()
        ElMessage.success('已退出登录')
        router.push('/')
      }).catch(() => {})
      break
  }
}

// 页面加载时获取用户信息
onMounted(async () => {
  if (userStore.isLoggedIn) {
    try {
      await userStore.getUserInfo()
    } catch (error) {
      console.error('获取用户信息失败:', error)
    }
  }
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
  Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.nav-left {
  display: flex;
  align-items: center;
}

.logo-link {
  display: flex;
  align-items: center;
  height: 32px;
}

.logo {
  height: 100%;
  width: auto;
  margin-right: 8px; /* 添加间距 */
}

.logo-text {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  text-decoration: none; /* 移除下划线 */
  transition: color 0.3s; /* 添加颜色过渡效果 */
}

.logo-text:hover {
  color: #409EFF; /* 鼠标悬浮时的颜色 */
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-profile {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-profile:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.username {
  margin: 0 8px;
  color: #333;
  font-size: 14px;
}

.publish-btn {
  height: 32px;
  padding: 0 16px;
}

/* 下拉菜单项样式 */
.el-dropdown-menu__item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.el-dropdown-menu__item .el-icon {
  margin-right: 4px;
}

/* 保持其他原有样式不变 */
.nav-links {
  display: flex;
  gap: 20px;
}

.nav-link {
  color: #333;
  text-decoration: none !important;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.nav-link:hover,
.nav-link.active {
  color: #1890ff;
  background: rgba(24, 144, 255, 0.1);
}

</style>

<style scoped>
/* 确保导航栏固定在顶部且有正确的 z-index */
.nav-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 为主内容添加顶部内边距，避免被导航栏遮挡 */
.main-container {
  padding-top: 60px; /* 根据导航栏高度调整 */
}
</style>
